import $ from 'jquery';
import { breakpoints } from './_site';
export const timeout = {};

export const updateDropdown = ($el) => {
    var text = $el.text(),
        $select = $el.closest('.pagelist-nav').siblings('.pagelist-dropdown');
    $select.text(text);
};

export const responsiveTabs = (flag) => {
    var $tabs = $('#pagelist-nav');

    if (flag) {
        $tabs.addClass('collapse');
    } else {
        $tabs.removeClass('collapse in').removeAttr('style');
    }
};

export const resize = () => {
    var $window = $(window);

    // md
    if ($window.width() < breakpoints.md) {
        responsiveTabs(true);
    } else {
        responsiveTabs(false);
    }
};

export const binds = () => {
    // ---------------- tab dropdown update
    $('.pagelist__link').on('click', function() {
        updateDropdown($(this));
    });

    // ---------------- window events
    $(window).on('resize.sideMenu', function() {
        clearTimeout(timeout.sideMenuResize);
        timeout.sideMenuResize = setTimeout(function() {
            resize();
        }, 100);
    });
    $(window).triggerHandler('resize.sideMenu');
};
